import { PriceExcludingWildMembership, PriceIncludingWildMembership } from '@/shared/types/prices';

export const getPriceByType = (
  prices: PriceIncludingWildMembership[],
  type: string,
): PriceIncludingWildMembership | undefined => prices.find((p) => p.type === type);

export const getPriceForCartByType = (
  prices: (PriceExcludingWildMembership | PriceIncludingWildMembership)[],
  type: string,
): PriceExcludingWildMembership | PriceIncludingWildMembership | undefined =>
  prices.find((p) => p.type === type);
